var _defs, _polygon, _polygon2, _polygon3, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _line, _circle, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _line2, _circle2, _line3, _circle3, _line4, _circle4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFourP1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 356.86 283.46",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#812990;}.cls-2{fill:#6b7b84;}.cls-3{fill:none;stroke:#f04e23;stroke-miterlimit:10;stroke-width:0.5px;}.cls-4{fill:#f04e23;}"))), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "202.02 283.46 31.94 283.46 116.98 141.73 287.06 141.73 202.02 283.46"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "202.02 0 116.98 141.73 31.94 0 202.02 0"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "116.98 141.73 202.02 0 287.06 141.73 116.98 141.73"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M4.09,45.2V38.53H6.77a2,2,0,1,1,0,4H4.92V45.2ZM8,40.54a1.24,1.24,0,0,0-1.33-1.27H4.92v2.54H6.67A1.24,1.24,0,0,0,8,40.54Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M9.52,42.78a2.42,2.42,0,0,1,2.38-2.53,2.35,2.35,0,0,1,2.32,2.59V43h-3.9a1.69,1.69,0,0,0,1.73,1.67,2.1,2.1,0,0,0,1.5-.62l.36.49a2.66,2.66,0,0,1-1.92.75A2.4,2.4,0,0,1,9.52,42.78Zm2.37-1.91a1.61,1.61,0,0,0-1.58,1.6h3.17A1.56,1.56,0,0,0,11.89,40.87Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M15.15,42.78a2.39,2.39,0,1,1,2.39,2.54A2.37,2.37,0,0,1,15.15,42.78Zm4,0a1.62,1.62,0,1,0-1.6,1.87A1.68,1.68,0,0,0,19.14,42.78Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M21.9,44.47V47h-.75V40.37h.75v.72a2,2,0,0,1,1.63-.84c1.27,0,2.15,1,2.15,2.53s-.88,2.54-2.15,2.54A2,2,0,0,1,21.9,44.47Zm3-1.69c0-1.07-.58-1.86-1.55-1.86a1.79,1.79,0,0,0-1.44.77v2.18a1.79,1.79,0,0,0,1.44.78C24.31,44.65,24.89,43.85,24.89,42.78Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M26.87,45.2V38.53h.75V45.2Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M28.84,42.78a2.42,2.42,0,0,1,2.38-2.53,2.35,2.35,0,0,1,2.32,2.59V43h-3.9a1.69,1.69,0,0,0,1.73,1.67,2.1,2.1,0,0,0,1.5-.62l.36.49a2.66,2.66,0,0,1-1.92.75A2.4,2.4,0,0,1,28.84,42.78Zm2.37-1.91a1.61,1.61,0,0,0-1.58,1.6H32.8A1.56,1.56,0,0,0,31.21,40.87Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M0,130.37v-6.66H2.68a2,2,0,1,1,0,4H.83v2.64Zm3.91-4.65a1.24,1.24,0,0,0-1.33-1.27H.83V127H2.58A1.24,1.24,0,0,0,3.91,125.72Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M5.84,130.37v-4.82h.75v.77a2.08,2.08,0,0,1,1.61-.88v.77l-.29,0a1.77,1.77,0,0,0-1.32.77v3.41Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M8.86,128a2.39,2.39,0,1,1,2.39,2.53A2.37,2.37,0,0,1,8.86,128Zm4,0a1.68,1.68,0,0,0-1.6-1.86,1.88,1.88,0,0,0,0,3.72A1.67,1.67,0,0,0,12.85,128Z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M14.58,128A2.39,2.39,0,0,1,17,125.43a2.07,2.07,0,0,1,1.77.84l-.5.45A1.42,1.42,0,0,0,17,126.1a1.87,1.87,0,0,0,0,3.72,1.47,1.47,0,0,0,1.23-.62l.5.45a2.07,2.07,0,0,1-1.77.84A2.39,2.39,0,0,1,14.58,128Z"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M19.54,128a2.42,2.42,0,0,1,2.38-2.53A2.35,2.35,0,0,1,24.24,128v.19h-3.9a1.68,1.68,0,0,0,1.73,1.66,2.1,2.1,0,0,0,1.5-.62l.36.49a2.66,2.66,0,0,1-1.92.75A2.39,2.39,0,0,1,19.54,128Zm2.37-1.91a1.61,1.61,0,0,0-1.58,1.6H23.5A1.56,1.56,0,0,0,21.91,126.05Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M25,129.73l.38-.53a2.22,2.22,0,0,0,1.59.68c.74,0,1.15-.34,1.15-.82,0-1.17-3-.45-3-2.24,0-.76.64-1.39,1.79-1.39a2.41,2.41,0,0,1,1.79.7l-.35.52A1.87,1.87,0,0,0,27,126c-.66,0-1.07.33-1.07.76,0,1,3,.36,3,2.24,0,.8-.65,1.45-1.89,1.45A2.59,2.59,0,0,1,25,129.73Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M29.69,129.73l.38-.53a2.22,2.22,0,0,0,1.59.68c.74,0,1.15-.34,1.15-.82,0-1.17-3-.45-3-2.24,0-.76.64-1.39,1.79-1.39a2.41,2.41,0,0,1,1.79.7l-.35.52a1.87,1.87,0,0,0-1.44-.61c-.66,0-1.07.33-1.07.76,0,1,3,.36,3,2.24,0,.8-.65,1.45-1.89,1.45A2.59,2.59,0,0,1,29.69,129.73Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M319.24,144.55v-6.67h2.68a2,2,0,1,1,0,4h-1.85v2.65Zm3.91-4.66a1.24,1.24,0,0,0-1.33-1.27h-1.75v2.54h1.75A1.24,1.24,0,0,0,323.15,139.89Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M325.08,144.55v-4.83h.75v.77a2.08,2.08,0,0,1,1.61-.88v.77l-.29,0a1.77,1.77,0,0,0-1.32.77v3.42Z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M328.1,142.13a2.39,2.39,0,1,1,2.39,2.54A2.37,2.37,0,0,1,328.1,142.13Zm4,0a1.62,1.62,0,1,0-1.6,1.87A1.68,1.68,0,0,0,332.09,142.13Z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M334.09,145.78l.38-.54a1.87,1.87,0,0,0,1.57.65,1.38,1.38,0,0,0,1.56-1.41v-.73a2.05,2.05,0,0,1-1.63.86,2.2,2.2,0,0,1-2.15-2.5c0-1.55.88-2.51,2.15-2.51a2,2,0,0,1,1.63.85v-.73h.75v4.76c0,1.53-1.13,2-2.31,2A2.47,2.47,0,0,1,334.09,145.78Zm3.51-2.62V141a1.83,1.83,0,0,0-1.44-.77c-1,0-1.56.77-1.56,1.84s.58,1.83,1.56,1.83A1.81,1.81,0,0,0,337.6,143.16Z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M339.85,144.55v-4.83h.75v.77a2.08,2.08,0,0,1,1.61-.88v.77l-.29,0a1.77,1.77,0,0,0-1.32.77v3.42Z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M342.87,142.13a2.42,2.42,0,0,1,2.38-2.53,2.34,2.34,0,0,1,2.31,2.59v.19h-3.89a1.69,1.69,0,0,0,1.73,1.67,2.1,2.1,0,0,0,1.5-.62l.36.49a2.66,2.66,0,0,1-1.92.75A2.4,2.4,0,0,1,342.87,142.13Zm2.37-1.91a1.61,1.61,0,0,0-1.58,1.6h3.17A1.56,1.56,0,0,0,345.24,140.22Z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M348.37,143.91l.38-.54a2.19,2.19,0,0,0,1.59.69c.74,0,1.15-.35,1.15-.83,0-1.17-3-.45-3-2.24,0-.76.64-1.39,1.79-1.39a2.41,2.41,0,0,1,1.79.7l-.35.52a1.87,1.87,0,0,0-1.44-.61c-.66,0-1.07.33-1.07.76,0,1.05,3,.36,3,2.24,0,.81-.65,1.46-1.89,1.46A2.59,2.59,0,0,1,348.37,143.91Z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M353,143.91l.38-.54a2.19,2.19,0,0,0,1.59.69c.74,0,1.15-.35,1.15-.83,0-1.17-3-.45-3-2.24,0-.76.64-1.39,1.79-1.39a2.41,2.41,0,0,1,1.79.7l-.35.52a1.87,1.87,0,0,0-1.44-.61c-.66,0-1.07.33-1.07.76,0,1.05,3,.36,3,2.24,0,.81-.65,1.46-1.89,1.46A2.59,2.59,0,0,1,353,143.91Z"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 36.91,
    y1: 42.39,
    x2: 109.55,
    y2: 42.39
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 111.78,
    cy: 42.39,
    r: 2.21
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M.73,243.84v-6.66H3.41a2,2,0,1,1,0,4H1.56v2.64Zm3.91-4.65a1.24,1.24,0,0,0-1.33-1.27H1.56v2.54H3.31A1.24,1.24,0,0,0,4.64,239.19Z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M6.57,243.84V239h.75v.77a2.08,2.08,0,0,1,1.61-.88v.77l-.29,0a1.77,1.77,0,0,0-1.32.77v3.41Z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M9.59,241.43A2.39,2.39,0,1,1,12,244,2.37,2.37,0,0,1,9.59,241.43Zm4,0a1.68,1.68,0,0,0-1.6-1.86,1.88,1.88,0,0,0,0,3.72A1.67,1.67,0,0,0,13.58,241.43Z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M19.09,243.84v-.72a2,2,0,0,1-1.63.84c-1.26,0-2.15-1-2.15-2.52s.89-2.54,2.15-2.54a2,2,0,0,1,1.63.85v-2.57h.75v6.66Zm0-1.31v-2.18a1.79,1.79,0,0,0-1.44-.78c-1,0-1.56.8-1.56,1.87s.58,1.85,1.56,1.85A1.78,1.78,0,0,0,19.09,242.53Z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M24.6,243.84v-.68a2.36,2.36,0,0,1-1.72.8,1.36,1.36,0,0,1-1.54-1.53V239h.75v3.18c0,.85.43,1.09,1.09,1.09a1.87,1.87,0,0,0,1.42-.72V239h.75v4.82Z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M26.57,241.43A2.39,2.39,0,0,1,29,238.9a2.07,2.07,0,0,1,1.77.84l-.5.45a1.42,1.42,0,0,0-1.23-.62,1.87,1.87,0,0,0,0,3.72,1.45,1.45,0,0,0,1.23-.62l.5.45A2.07,2.07,0,0,1,29,244,2.39,2.39,0,0,1,26.57,241.43Z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M32,242.84v-3.16h-.8V239H32V237.7h.76V239h1v.66h-1v3c0,.36.16.61.48.61a.67.67,0,0,0,.51-.21l.22.57A1.22,1.22,0,0,1,33,244,1,1,0,0,1,32,242.84Z"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 36.91,
    y1: 241.03,
    x2: 109.55,
    y2: 241.03
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 111.78,
    cy: 241.03,
    r: 2.21
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 36.91,
    y1: 127.56,
    x2: 159.55,
    y2: 127.56
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 161.78,
    cy: 127.56,
    r: 2.21
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 287.06,
    y1: 141.73,
    x2: 309.7,
    y2: 141.73
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 311.93,
    cy: 141.73,
    r: 2.21
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFourP1);
export default __webpack_public_path__ + "static/media/FourP1.f3d5ee441fb4c53a063435a4b878e3a1.svg";
export { ForwardRef as ReactComponent };